export default __webpack_public_path__ + "static/media/Quiken_Miles_Guias_generadas.290a52df.png";